function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';

var ResolveTheme = /*#__PURE__*/function (_React$Component) {
  _inherits(ResolveTheme, _React$Component);

  var _super = _createSuper(ResolveTheme);

  function ResolveTheme(props) {
    var _this;

    _classCallCheck(this, ResolveTheme);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getTheme", function (node) {
      var currentNode = node;

      while (currentNode.parentElement) {
        if (currentNode.classList.contains('psw-dark-theme')) return 'dark';
        if (currentNode.classList.contains('psw-light-theme')) return 'light';
        currentNode = currentNode.parentElement;
      }

      return 'light';
    });

    _this.ref = props.node || /*#__PURE__*/React.createRef();
    _this.state = {
      theme: ''
    };
    return _this;
  }

  _createClass(ResolveTheme, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var currentRef = this.ref.current;
      this.setState({
        theme: this.getTheme(currentRef)
      });
    } // traverse DOM to get the theme of closest parent node

  }, {
    key: "render",
    value: function render() {
      var theme = this.state.theme;
      var _this$props = this.props,
          children = _this$props.children,
          node = _this$props.node,
          className = _this$props.className;
      if (node) return children({
        theme: theme
      });
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        ref: this.ref
      }, children({
        theme: theme
      }));
    }
  }]);

  return ResolveTheme;
}(React.Component);

ResolveTheme.defaultProps = {
  node: null,
  children: function children() {},
  className: ''
};
ResolveTheme.propTypes = {
  /**
   *  A passed in ref, if one is not passed in the one will be created
   */
  node: PropTypes.shape({
    current: PropTypes.any
  }),
  children: PropTypes.func,
  className: PropTypes.string
};
export default ResolveTheme;